import { render, staticRenderFns } from "./HomePartenaire.vue?vue&type=template&id=4b6851c0&scoped=true"
import script from "./HomePartenaire.vue?vue&type=script&lang=js"
export * from "./HomePartenaire.vue?vue&type=script&lang=js"
import style0 from "./HomePartenaire.vue?vue&type=style&index=0&id=4b6851c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6851c0",
  null
  
)

export default component.exports